<script>
import FooterView from '../../shared/views/MainFooterView';
import BrandLogo from '../../shared/BrandLogo.vue';
export default {
  name: 'SupportPageView',
  components: {
        'brand-logo': BrandLogo,
    'footer-view': FooterView,
  },
  data() {
    return {
      activeTopic: 'pagos',
    };
  },
  methods: {
    setTopic(topic) {
      this.activeTopic = topic;
    },
  },
};
</script>

<template>
  <div class="public-page-wrapper">
    <!-- Header -->
    <header class="public-header">
      <div class="public-header__inner">
        <router-link to="/">
          <brand-logo variant="dark" />
        </router-link>
        <nav class="public-header__nav">
          <router-link to="/">Inicio</router-link>
          <router-link to="/acerca">Acerca</router-link>
          <router-link to="/cursos">Cursos</router-link>
          <router-link to="/noticias">Noticias</router-link>
          <router-link to="/contacto">Contacto</router-link>
        </nav>
        <div class="public-header__actions">
          <router-link
            to="/login"
            class="btn-outline"
          >
            Iniciar Sesión
          </router-link>
          <router-link
            to="/registrarse"
            class="btn-fill"
          >
            Registrarse
          </router-link>
        </div>
      </div>
    </header>

    <!-- Hero -->
    <section class="public-hero">
      <div class="public-hero__inner">
        <nav class="public-hero__nav">
          <router-link to="/">Inicio</router-link>
          <span>/</span>
          <a
            href="#"
            class="active"
          >Soporte</a>
        </nav>
        <h1 class="public-hero__title">Centro de Soporte</h1>
        <p class="public-hero__subtitle">Encuentra respuestas a tus preguntas o contacta a nuestro equipo de ayuda.</p>
      </div>
    </section>

    <!-- Body -->
    <main class="public-body">
      <div class="row">
        <!-- Sidebar -->
        <div class="col-lg-3 col-md-4 mb-24">
          <div class="public-card support-sidebar">
            <div class="public-card__accent-bar" />
            <h3>Temas de Ayuda</h3>
            <ul class="public-sidebar__list">
              <li>
                <a
                  href="#"
                  :class="{ active: activeTopic === 'cuentas' }"
                  @click.prevent="setTopic('cuentas')"
                >
                  <i class="uil uil-user" /> Cuentas
                </a>
              </li>
              <li>
                <a
                  href="#"
                  :class="{ active: activeTopic === 'pagos' }"
                  @click.prevent="setTopic('pagos')"
                >
                  <i class="uil uil-credit-card" /> Pagos
                </a>
              </li>
              <li>
                <a
                  href="#"
                  :class="{ active: activeTopic === 'simuladores' }"
                  @click.prevent="setTopic('simuladores')"
                >
                  <i class="uil uil-monitor" /> Simuladores
                </a>
              </li>
              <li>
                <a
                  href="#"
                  :class="{ active: activeTopic === 'cursos' }"
                  @click.prevent="setTopic('cursos')"
                >
                  <i class="uil uil-book-open" /> Creación de Cursos
                </a>
              </li>
              <li>
                <a
                  href="#"
                  :class="{ active: activeTopic === 'examenes' }"
                  @click.prevent="setTopic('examenes')"
                >
                  <i class="uil uil-chart-line" /> Exámenes
                </a>
              </li>
              <li>
                <a
                  href="#"
                  :class="{ active: activeTopic === 'general' }"
                  @click.prevent="setTopic('general')"
                >
                  <i class="uil uil-question-circle" /> Preguntas Frecuentes
                </a>
              </li>
            </ul>
            <div class="support-contact-box">
              <h4>¿No encontraste lo que buscabas?</h4>
              <p>Nuestro equipo está listo para ayudarte.</p>
              <router-link
                to="/contacto"
                class="btn-fill support-contact-btn"
              >
                <i class="uil uil-envelope" /> Contactar Soporte
              </router-link>
            </div>
          </div>
        </div>

        <!-- Content -->
        <div class="col-lg-9 col-md-8">
          <!-- Cuentas -->
          <div
            v-if="activeTopic === 'cuentas'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <h3>Cuentas de Usuario</h3>
            <p>
              Gestiona tu cuenta de AppMisionate, actualiza tu información personal y aprende a
              resolver problemas comunes relacionados con el acceso a tu cuenta.
            </p>
            <div class="public-card__divider" />
            <h4>¿Cómo creo una cuenta?</h4>
            <p>
              Haz clic en "Registrarse" en la página principal, completa el formulario con tus
              datos personales y verifica tu correo electrónico para activar tu cuenta.
            </p>
            <div class="public-card__divider" />
            <h4>¿Olvidé mi contraseña, qué hago?</h4>
            <p>
              Haz clic en "¿Olvidaste tu contraseña?" en la página de inicio de sesión e ingresa
              tu correo electrónico. Recibirás un enlace para restablecer tu contraseña.
            </p>
            <div class="public-card__divider" />
            <h4>¿Cómo actualizo mi información de perfil?</h4>
            <p>
              Inicia sesión, ve a tu perfil y haz clic en "Editar perfil". Desde allí podrás
              modificar tu nombre, foto, correo electrónico y contraseña.
            </p>
          </div>

          <!-- Pagos -->
          <div
            v-if="activeTopic === 'pagos'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <h3>Pagos y Facturación</h3>
            <p>
              Resuelve tus dudas sobre métodos de pago, facturas, devoluciones y el uso de
              cupones de descuento en AppMisionate.
            </p>
            <div class="public-card__divider" />
            <h4>Métodos de pago aceptados</h4>
            <ul>
              <li>Tarjeta de crédito y débito (Visa, Mastercard, AMEX)</li>
              <li>PayPal</li>
              <li>Transferencia bancaria (solo suscripciones anuales)</li>
              <li>Cupones de descuento emitidos por AppMisionate</li>
            </ul>
            <div class="public-card__divider" />
            <h4>¿Cómo usar un cupón de descuento?</h4>
            <ul>
              <li>Solicita tu cupón a través de los canales autorizados</li>
              <li>Inicia sesión y ve a la sección de tu perfil</li>
              <li>Actualiza tu inscripción o selecciona el plan deseado</li>
              <li>Ingresa el código del cupón en el campo correspondiente</li>
              <li>Continúa con el proceso de pago</li>
            </ul>
            <div class="public-card__divider" />
            <h4>¿Cómo solicito una devolución?</h4>
            <p>
              Las solicitudes de devolución se evalúan dentro de los primeros 7 días posteriores
              a la compra, siempre que no hayas avanzado más del 20% del contenido. Contacta
              a soporte con tu número de pedido.
            </p>
            <div class="public-card__divider" />
            <h4>¿Por qué no debo compartir mi cupón?</h4>
            <p>
              Los cupones son personales e intransferibles. Compartir tu código puede resultar
              en la invalidación del cupón y la suspensión de tu cuenta.
            </p>
          </div>

          <!-- Simuladores -->
          <div
            v-if="activeTopic === 'simuladores'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <h3>Simuladores</h3>
            <p>
              Nuestros simuladores están diseñados para complementar tu aprendizaje. Aprende
              cómo acceder, navegar y aprovechar al máximo estas herramientas educativas.
            </p>
            <div class="public-card__divider" />
            <h4>¿Cómo accedo a los simuladores?</h4>
            <p>
              Los simuladores están disponibles dentro de cada curso como parte del contenido
              complementario. Una vez inscrito, aparecerán en la sección correspondiente.
            </p>
            <div class="public-card__divider" />
            <h4>¿Necesito software adicional?</h4>
            <p>
              No. Nuestros simuladores funcionan directamente en el navegador. Solo necesitas
              una conexión a internet estable y un navegador actualizado (Chrome, Firefox,
              Edge o Safari).
            </p>
            <div class="public-card__divider" />
            <h4>¿Puedo usar el simulador desde mi celular?</h4>
            <p>
              Sí. Los simuladores son compatibles con dispositivos móviles. Para una mejor
              experiencia, recomendamos usar una tablet o computadora de escritorio.
            </p>
          </div>

          <!-- Creación de Cursos -->
          <div
            v-if="activeTopic === 'cursos'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <h3>Creación de Cursos</h3>
            <p>
              Si eres asesor educativo, aquí encontrarás información sobre cómo crear, publicar
              y gestionar tus cursos en la plataforma.
            </p>
            <div class="public-card__divider" />
            <h4>Requisitos para crear un curso</h4>
            <ul>
              <li>Tener una cuenta de asesor verificada</li>
              <li>Completar el perfil de instructor</li>
              <li>Firmar el acuerdo de colaboración</li>
              <li>Subir al menos un módulo de contenido</li>
            </ul>
            <div class="public-card__divider" />
            <h4>¿Qué tipos de contenido puedo subir?</h4>
            <p>
              Puedes subir videos, documentos PDF, presentaciones, enlaces externos, evaluaciones
              y simuladores interactivos. Todos los materiales deben ser de tu autoría o contar
              con la licencia correspondiente.
            </p>
            <div class="public-card__divider" />
            <h4>Tiempo de revisión</h4>
            <p>
              Una vez publicado, tu curso pasa por un proceso de revisión que puede tardar
              entre 3 y 5 días hábiles. Te notificaremos por correo sobre el resultado.
            </p>
          </div>

          <!-- Exámenes -->
          <div
            v-if="activeTopic === 'examenes'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <h3>Exámenes y Evaluaciones</h3>
            <p>
              Conoce cómo funcionan nuestros sistemas de evaluación, cómo presentar exámenes y
              cómo obtener tus certificados.
            </p>
            <div class="public-card__divider" />
            <h4>¿Cómo presento un examen?</h4>
            <p>
              Los exámenes aparecen disponibles al completar los módulos previos del curso.
              Haz clic en "Iniciar examen" y completa las preguntas dentro del tiempo
              establecido.
            </p>
            <div class="public-card__divider" />
            <h4>¿Cuántas veces puedo presentar un examen?</h4>
            <p>
              Cada curso define su propia política de intentos. Consulta la información del
              curso para conocer el número máximo de intentos permitidos.
            </p>
            <div class="public-card__divider" />
            <h4>¿Cómo obtengo mi certificado?</h4>
            <p>
              Al aprobar todas las evaluaciones de un curso, recibirás un certificado digital
              que podrás descargar desde la sección "Mis certificados" en tu perfil.
            </p>
          </div>

          <!-- Preguntas Frecuentes -->
          <div
            v-if="activeTopic === 'general'"
            class="public-card"
          >
            <div class="public-card__accent-bar" />
            <h3>Preguntas Frecuentes</h3>
            <p>
              Respuestas rápidas a las dudas más comunes sobre AppMisionate.
            </p>
            <div class="public-card__divider" />
            <h4>¿AppMisionate ofrece certificados?</h4>
            <p>
              Sí. Al completar un curso y aprobar sus evaluaciones, recibirás un certificado
              digital válido para respaldar tu formación.
            </p>
            <div class="public-card__divider" />
            <h4>¿Los cursos tienen vigencia?</h4>
            <p>
              Una vez matriculado, tienes acceso al contenido por un período de 12 meses.
              Los simuladores pueden tener acceso limitado según el plan.
            </p>
            <div class="public-card__divider" />
            <h4>¿Puedo descargar los videos?</h4>
            <p>
              No. Los videos son contenido protegido y no pueden ser descargados. Sí puedes
              acceder a ellos en cualquier momento desde tu cuenta.
            </p>
            <div class="public-card__divider" />
            <h4>¿Cómo contacto a soporte técnico?</h4>
            <p>
              Puedes contactarnos a través de la <router-link to="/contacto">página de contacto</router-link>
              o escribirnos a <strong>soporte@appmisionate.com</strong>.
              Nuestro horario de atención es de lunes a viernes de 9:00 a 18:00 horas.
            </p>
          </div>
        </div>
      </div>
    </main>

    <footer-view />
  </div>
</template>

<style scoped>
.mb-24 {
  margin-bottom: 24px;
}

.support-sidebar {
  padding: 20px;
}

.support-sidebar h3 {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 16px;
}

.support-sidebar .public-sidebar__list {
  margin-bottom: 20px;
}

.support-contact-box {
  background: linear-gradient(135deg, #EEF5FC, #D6E7F8);
  border-radius: 10px;
  padding: 16px;
  margin-top: 16px;
  text-align: center;
}

.support-contact-box h4 {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0 0 6px;
}

.support-contact-box p {
  font-size: 0.8125rem;
  color: #64748b;
  margin: 0 0 12px;
  line-height: 1.5;
}

.support-contact-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.8125rem;
  padding: 8px 16px;
  border-radius: 8px;
}
</style>
